const { rendering, warmupData } = require('@wix/site-window');

async function withWarmUpData(functionName, func, log) {
  const message = msg => log(`withWarmUpData ${functionName}: ${msg}`);
  const start = Date.now();

  let result;
  const renderingEnv = await rendering.env();
  if (renderingEnv === 'backend') {
    message('running function');
    result = await func();
    message('saving data in warmup');
    await warmupData.set(functionName, result);
    message('data saved in warmup');
  } else if (renderingEnv === 'browser') {
    // browser
    const resultOfFunctionInBackend = await warmupData.get(functionName);
    if (resultOfFunctionInBackend) {
      message('found data in warmup');
      result = resultOfFunctionInBackend;
    } else {
      message('no warmup data found, running function');
      result = await func();
    }
  } else {
    throw new Error(`Unknown rendering environment: ${renderingEnv}`);
  }

  const duration = Date.now() - start;
  message(
    'duration: ' +
      duration +
      'ms and in human readable format: ' +
      (duration / 1000).toFixed(2) +
      's'
  );
  return result;
}

const memoizationMap = new Map();
async function withMemoization(functionName, func, log) {
  if (memoizationMap.has(functionName)) {
    log(`found data in memoization for ${functionName}`);
    return memoizationMap.get(functionName);
  }

  log(`no data found in memoization for ${functionName}, running function`);
  const result = await func();
  memoizationMap.set(functionName, result);
  return result;
}
module.exports = {
  withMemoization,
  withWarmUpData,
};
